import { AuthBy } from '@/util/composables/useLocalStorage'
import { checkToken } from '~/util/helpers/checkToken'
import { ENUM_CATEGORY } from '@/components/Lobby/enum.js'

export default function ({ store, req, redirect, query, $paths }) {
  let token = store.getters['user/isLoggedIn']

  if (req && !token) {
    // gets token in request from the server
    token = checkToken(req)
  }

  if (!token) {
    /** Server logic */
    if (process.server) {
      redirect({
        path: $paths.home,
        query: { ...query, redirected: true },
      })
    }
    /** Client logic */
    else {
      const payload = { path: $paths.home, query }
      AuthBy.value
        ? Object.assign(payload.query, { bigModal: 'auth', bigModalTab: AuthBy.value })
        : Object.assign(payload.query, { bigModal: 'registration', bigModalTab: 'phone' })
      redirect(payload)
    }
  }
  /** MB unnecessary */
  if (!process.client) return
  store.commit('user/SET_USER_TOKEN')
}
